import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
  useTransition,
} from "react";
import {
  Col,
  // eslint-disable-next-line
  Dropdown,
  Table,
  Button,
  Checkbox,
  Avatar,
  Typography,
  // eslint-disable-next-line
  Menu,
  Affix,
  Popconfirm,
  AutoComplete,
  Spin,
} from "antd";
import {
  CaretUpOutlined,
  CaretDownOutlined,
  // eslint-disable-next-line
  CloseSquareFilled,
  HolderOutlined,
} from "@ant-design/icons";

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  SortableContext,
  arrayMove,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ReactComponent as UploadImage } from "../../../../../assets/icons/uploadImage.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/icons/DeleteIconTable.svg";
import "./CreateQuoteTable.css";
import TextArea from "antd/es/input/TextArea";
import AddImages from "../../../../../components/Modal/Table/AddImages";
import MoveItemModal from "../../../../../components/Modal/Table/MoveItemModal";
import Checkout from "../Checkout";
import {
  useCreateRFQQuoteMutation,
  useDeleteQuoteItemMutation,
  useDeleteQuoteTableMutation,
  useLazyGetCatalogueByVendorDrawerQuery,
  useLazyGetCatalogueByVendorModalQuery,
  useLazyGetCatalogueByVendorQuery,
  useLazyGetRFQQuoteDetailQuery,
  useLazyGetRFQUserByIdQuery,
  useQuoteExcelPreviewMutation,
  useUpdateRFQQuoteDetailsMutation,
  useLazyGetReportingManagersQuery,
} from "../../../../../apis/createQuote";
import { useDispatch, useSelector } from "react-redux";
import EmptyTable from "./EmptyTable";
import TableHeader from "./TableHeader/TableHeader";
import TableFooter from "./TableFooter/TableFooter";
import {
  addressFlagSelector,
  billingAddressSelector,
  bmpPriceSelector,
  catalogueSelector,
  deliveryAddressSelector,
  editQuoteDataSelector,
  grandPriceSelector,
  vendorListSelector,
} from "../../../../../redux/slices/createQuote/selector";
import {
  getAllVendors,
  getBillingAddress,
  getBillingAddressList,
  getBmpPrice,
  getCatalogueByVendor,
  getDeliveryAddress,
  getDeliveryAddressList,
  getGrandPrice,
  getRFQQuoteData,
  getRFQUserById,
  updateAddressFlag,
} from "../../../../../redux/slices/createQuote/action";
import CreateQuoteProfileSection from "../CreateQuoteProfileSection/CreateQuoteProfileSection";
import { debounce } from "lodash";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../../NotificationToast/NotificationToast";
import { useNavigate, useParams } from "react-router-dom";
import { getRFQListFlag } from "../../../../../redux/slices/rfqList/action";
import { useConvertToOrderAPIMutation } from "../../../../../apis/ManageOrders";
import UnitNameCell from "./TableComponents/UnitNameCell/UnitNameCell";
import {
  priceAfterTax,
  totalPrice,
} from "../../../../../commonFuntions/CommonUtilFunctions";
import GstCell from "./TableComponents/GstCell/GstCell";
import { baseUrl } from "../../../../../commonUtils/commonUtils";
import CancelCreateQuoteModal from "../../../../../components/Modal/CancelModal/CancelCreateQuoteModal";
import TableSkeleton from "../../../../../components/skeleton/TableSkeleton";
import { QuoteLoading } from "../../../../Animations/QuoteLoading/QuoteLoading";
import {
  getCreateOrderDrawerProductData,
  getCreateOrderModalProductData,
} from "../../../../../redux/slices/createOrder/action";
import {
  extractQuoteExcelPreviewGroups,
  isExcelFile,
  mergeQuoteExcelPreviewData,
} from "../../../../../commonUtils/quoteExcelPreview";

import QuoteConfirmationModal from "../../../../../components/Modal/UpdateRedundantModal/QuoteConfirmationModal";
import CreateQuoteValidationModal from "../../../../../components/Modal/CancelModal/CreateQuoteValidationModal";
import { unitOptions } from "../../../../ManageOrders/OrderDetails/OrderConstant/Constant";
const { Text } = Typography;

const DragHandleContext = createContext(null);

const DragHandle = () => {
  const dragHandle = useContext(DragHandleContext);

  if (!dragHandle) {
    return null;
  }

  const { attributes, listeners, setActivatorNodeRef } = dragHandle;

  return (
    <HolderOutlined
      ref={setActivatorNodeRef}
      {...attributes}
      {...listeners}
      title="Drag to reorder"
      style={{
        cursor: "grab",
        color: "#8c8c8c",
        fontSize: "18px",
        touchAction: "none",
        userSelect: "none",
        backgroundColor: "rgb(243, 242, 239)",
        borderRadius: "8px",
        height: "27px",
        padding:"6px"
      }}
    />
  );
};

const DraggableRow = ({ children, ...props }) => {
  const rowKey = props["data-row-key"];

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: String(rowKey),
  });

    const style = {
    ...props.style,
    transform: CSS.Transform.toString(transform),
    transition,

    // Keep the dragged row white
    backgroundColor: isDragging ? "#fff" : props.style?.backgroundColor,

    // Optional: slight visual elevation while dragging
    boxShadow: isDragging
      ? "0 4px 12px rgba(0, 0, 0, 0.12)"
      : undefined,

    position: isDragging ? "relative" : undefined,
    zIndex: isDragging ? 999 : undefined,
  };
  return (
    <DragHandleContext.Provider
      value={{
        attributes,
        listeners,
        setActivatorNodeRef,
      }}
    >
      <tr {...props} ref={setNodeRef} style={style}>
        {children}
      </tr>
    </DragHandleContext.Provider>
  );
};
const data = [
  {
    key: 1,
    input: "",
    unit_name: "",
    imageURL: "",
    hsn_sac: "",
    before_tax: "",
    gst: 0,
    after_tax: "",
    amount_in: "amount",
    amount: "",
    bmp_price: "",
    discount: 0,
    quantity: 0,
    total: 0,
    mob_margin: { amount_in: "amount", amount: 0 },
  },
];

const CreateQuoteTable = () => {
  const dispatch = useDispatch();

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 6,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );
  const navigate = useNavigate();
  const params = useParams();
  const rfqId = params?.rfq_id;
  const quoteId = params?.quote_id;
  const bmpPrice = useSelector(bmpPriceSelector);
  const grandPrice = useSelector(grandPriceSelector);
  const delivery_address = useSelector(deliveryAddressSelector);
  const billing_address = useSelector(billingAddressSelector);
  const sellerList = useSelector(vendorListSelector);
  const editQuoteData = useSelector(editQuoteDataSelector);
  const addressFlag = useSelector(addressFlagSelector);
  const editCondition = rfqId && quoteId ? true : false;
  // eslint-disable-next-line
  const productList = useSelector(catalogueSelector);
  const [dataSource, setDataSource] = useState([data]); // This is for providing data of tables

  const [count, setCount] = useState([data.length]); // This is for providing unique key to each row of table
  const [selectedSeller, setSelectedSeller] = useState([]); // This Array for sellecting the seller of table
  const [addImageModal, setAddImageModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [currentIndexTable, setCurrentIndexTable] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isFixedBarVisible, setIsFixedBarVisible] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [trigger, catalogueList] = useLazyGetCatalogueByVendorQuery();
  const [ewaybilltrigger, setEwaybilltrigger] = useState(true);
  const [errorMessages, setErrorMessages] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const [showFieldErrors, setShowFieldErrors] = useState(false);
  const [dropDownList, setDropDownList] = useState([]);
  const [activeItemSearchKey, setActiveItemSearchKey] = useState(null);

  const [getcatalogueListDrawerApi, { data: catalogueListDrawerData }] =
    useLazyGetCatalogueByVendorDrawerQuery();
  const [
    getProductCatalogueDataApi,
    {
      data: productCatalogueData,
      isSuccess: isSuccessProductCatalogueData,
      isFetching: isFetchingProductCatalogueData,
    },
  ] = useLazyGetCatalogueByVendorModalQuery();
  const [getRFQUserApi, quoteData] = useLazyGetRFQUserByIdQuery();

  const [getRFQQuoteDetailApi, editData] = useLazyGetRFQQuoteDetailQuery();
  const [deletTableRowApi] = useDeleteQuoteItemMutation();
  const [deletTableApi] = useDeleteQuoteTableMutation();
  const [createRFQQuoteApi, { isLoading: isCreateLoading }] =
    useCreateRFQQuoteMutation();
  const [updateRFQQuoteApi, { isLoading: isUpdateLoading }] =
    useUpdateRFQQuoteDetailsMutation();
  const [quoteExcelPreviewApi, { isLoading: isExcelPreviewApiLoading }] =
    useQuoteExcelPreviewMutation();
  const [convertOrderApi] = useConvertToOrderAPIMutation();
  const [excelUploadTableIndex, setExcelUploadTableIndex] = useState(null);
  const [isExcelProcessing, setIsExcelProcessing] = useState(false);
  const [isExcelUiPending, startExcelImportTransition] = useTransition();
  const inputUndoHistoryRef = useRef({});

  const handleCancelModal = () => {
    setCancelModal(false);
  };
  const handleCancelOpenModal = () => {
    setCancelModal(true);
  };
  const handleErrorModal = () => {
    setErrorModal(false);
  };
  const handleEditDataSource = (editData) => {
    if (!editData?.id) return {};
    const grandPrice = {
      terms_and_condition: editData?.terms_and_condition,
      add_additional_discount: editData?.add_additional_discount,
      additional_discount: editData?.additional_discount,
      cgst: editData?.cgst,
      discount: editData?.discount,
      igst: editData?.sgst,
      sgst: editData?.sgst,
      sub_total: editData?.sub_total,
      total: editData?.total,
      ewaybilltrigger: editData?.ewaybilltrigger,
    };
    const arr = Object?.entries(editData?.quote_items);
    // const venderList = arr.map((item, index) => {
    //   return item[0];
    // });
    // const venderList = arr.map((item) => item[0]?.replace(/_\d+$/, ""));
    const venderList = arr.map((item) => {
      const vendorKey = item[0];
      if (/^MOB_ALL_\d+$/.test(vendorKey || "")) {
        return vendorKey;
      }
      return vendorKey?.replace(/_\d+$/, "");
    });
    const bmpData = [];
    const tableData = arr.map((item, index) => {
      bmpData.push({
        additional_bmp_discount: item[1].additional_bmp_discount,
        additional_bmp_discount_in: item[1].additional_bmp_discount_in,
        delivery_fee: item[1].delivery_fee,
        quote_delivery_dates: item[1]?.quote_delivery_dates,
        quote_delivery_slot: item[1]?.quote_delivery_slot,
        quote_delivery_notes: item[1]?.quote_delivery_notes,
        quote_vendor: item[1]?.quote_vendor,
        index: index,
      });

      const table = item[1].items.map((row, i) => {
        const matchingUnit = unitOptions.find(
          (unit) => unit.code === row.unit?.toUpperCase(),
        );

        const unitName = matchingUnit ? matchingUnit.code : "";

        const obj = {
          before_tax: row.price_before_tax,
          after_tax: row.price_after_tax,
          gst: row.gst,
          id: row.id,
          imageURL: row.product.product_image,
          key: i + 1,
          input: row.product.product_name,
          unit_name: row.unit === "0" ? "" : unitName,
          hsn_sac: row?.product?.hsn_code || "",
          amount_in: row.margin_value,
          amount: row.mob_margin,
          bmp_price: row.bmp_price,
          discount: row.discount,
          quantity: row.quantity,
          total: row.total,
          mob_sku: row.product.mob_sku,
          quote_vendor: row?.quote_vendor,
          vendor_selling_price: row?.product?.price_before_tax,
          rfq_price: row?.product?.rfq_price_before_tax,
        };
        return obj;
      });

      return table;
    });
    return { venderList, tableData, bmpData, grandPrice };
  };

  const initialValue =
    editCondition && editData?.status === "fulfilled"
      ? handleEditDataSource(editQuoteData)
      : "";

  const cancelQuote = () => {
    navigate(`/admin/rfq/quotes/${rfqId}`);
    setDataSource([data]);
    setSelectedSeller([]);
    dispatch(getRFQQuoteData({}));
    dispatch(getDeliveryAddress({}));
    dispatch(getBillingAddress({}));
    dispatch(getBmpPrice([]));
    dispatch(getGrandPrice({}));
    dispatch(getRFQListFlag(true));
    setLoader(false);
    setShowFieldErrors(false);
  };
  function checkBmpIdPresence(arrayOfObjects) {
    for (let obj of arrayOfObjects) {
      if (!obj.hasOwnProperty("bmp_id")) {
        return false; // Return false if bmp_id key is not present in any object
      }
    }
    return true; // Return true if all objects have bmp_id key
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showConfirmationModal = () => {
    setIsModalOpen(true);
  };

  const handleCreateQuote = async (orderCheck) => {
    setLoader(true);
    let errorCheck = handleCheckError();
    if (errorCheck?.check) {
      setIsModalOpen(false);
      setLoader(false);
      setErrorMessages(errorCheck?.groupedErrors || []);
      setErrorModal(true);
      setShowFieldErrors(true);
      return;
    }
    if (!checkBmpIdPresence(selectedSeller)) {
      showErrorToast("Please select vendor");
      setLoader(false);
      return;
    }
    const params = {
      ...(quoteId && { quote_id: quoteId }),
      ...(rfqId && { rfq_order_id: rfqId }),
      quote_comments: "",
      delivery_fee: 0,
      address: {
        delivery_address: delivery_address.id,
        billing_address: billing_address.id,
      },
      sub_total: grandPrice.sub_total,
      discount: grandPrice.discount,
      sgst: grandPrice?.cgst,
      cgst: grandPrice?.cgst,
      igst: grandPrice?.igst,
      additional_discount: grandPrice?.add_additional_discount || 0,
      add_additional_discount: grandPrice?.add_additional_discount || 0,
      total: grandPrice.total,
      terms_and_condition: grandPrice.terms_and_condition || "",
      quote_items: {},
      generate_eway: ewaybilltrigger,
    };

    for (let i = 0; i < selectedSeller.length; i++) {
      const tableData = [];
      dataSource[i].map((rows, index) => {
        tableData.push({
          unit: rows.unit_name || 0,
          index: index,
          gst: rows.gst || 0,
          price_before_tax: rows.before_tax || 0,
          price_after_tax: rows.after_tax || 0,
          discount: rows.discount || 0,
          quantity: rows.quantity,
          total: rows.total,
          hsn_code: rows.hsn_sac || "",
          mob_margin: {
            amount_in: rows.amount_in,
            amount: rows.amount || 0,
          },
          bmp_price: rows.bmp_price || 0,
          ...(rfqId && {
            vendor: selectedSeller[i].bmp_id,
            // vendor_product: rows.mob_sku || rows.input,
            vendor_product: rows.input || rows.mob_sku,
            product_image: rows.imageURL || "No Image",
          }),
          ...(quoteId && {
            product: {
              vendor: selectedSeller[i].bmp_id,
              // product_name: rows.mob_sku || rows.input,
              product_name: rows.input || rows.mob_sku,
              product_image: rows.imageURL || "No Image",
            },
          }),
          ...(quoteId && {
            quote_vendor: rows.quote_vendor,
          }),
          ...(rows.id && {
            id: rows.id,
          }),
        });
        return null;
      });
      params.quote_items[selectedSeller[i].bmp_id] = {
        total_bmp_price: bmpPrice[i].total_bmp_price || 0,
        additional_bmp_price: bmpPrice[i].additional_bmp_price || 0,
        delivery_fee: bmpPrice[i].delivery_fee || 0,
        discount: bmpPrice[i].discountPrice || 0,
        total_of_quote_items: bmpPrice[i].subTotal,
        quote_delivery_notes: bmpPrice[i].quote_delivery_notes,
        quote_delivery_dates: bmpPrice[i].quote_delivery_dates,
        quote_delivery_slot: bmpPrice[i].quote_delivery_slot,
        sgst: bmpPrice[i].sgst || 0,
        cgst: bmpPrice[i].sgst || 0,
        igst: bmpPrice[i].igst || 0,
        additional_bmp_discount: bmpPrice[i].additional_bmp_discount || 0,
        additional_bmp_discount_in: bmpPrice[i].additional_bmp_discount_in,
        final_bmp_price: bmpPrice[i].final_bmp_price || 0,
        sub_total: bmpPrice[i].subTotal || 0,
        ...(rfqId && {
          quote_vendor: bmpPrice[i].quote_vendor,
        }),
        items: tableData,
      };
    }

    params.reporting_manager = reportingManager?.id;

    if (rfqId && !quoteId) {
      const response = await createRFQQuoteApi(params);
      // console.log("🚀 ~ response:", response)
      if (response?.data?.message && response?.data?.status) {
        // const itemsValidation = Object.values(
        //   response?.data?.data?.quote_items
        // );
        // ------------If every row needs to be filled
        // const itemWithZeroQuantity = itemsValidation?.find((obj) => {
        //   return obj?.items.find((item) => {
        //       return item.quantity === 0
        // });

        // ------------If alteast one row needs to be filled
        // const itemWithZeroQuantity = itemsValidation?.some((obj) => {
        //   return obj?.items.some((item) => {
        //     return item?.quantity > 0 && item?.gst;
        //   });
        // });
        // if (!itemsValidation.length) {
        //   showErrorToast("Please add atleast one quote!");
        //   setLoader(false);
        //   return;
        // }
        // if (itemsValidation.length && !itemWithZeroQuantity) {
        //   showErrorToast("Quantity can not be 0!");
        //   setLoader(false);
        //   return;
        // }
        showSuccessToast(response.data.message);
        setTimeout(() => {
          cancelQuote();
        }, 5000);
      } else {
        const inputFieldsValidation = response?.error?.data
          ? Object.keys(response?.error?.data)[0]
          : "Please check quote fields!";
        const errorMsg = handleErrorMsg(
          response?.error?.data?.message || inputFieldsValidation,
        );
        showErrorToast(errorMsg);
        setLoader(false);

        if (response?.error?.data?.data?.errors) {
          const errors = response?.error?.data?.data?.errors;
          if (Array.isArray(errors)) {
            const errorMessages = errors.map((error) => error);
            setIsModalOpen(false);
            setErrorModal(true);
            setErrorMessages(errorMessages);
          }
        }
      }
    } else {
      const response = await updateRFQQuoteApi(params);

      if (response?.data?.message && response?.data?.status) {
        if (orderCheck !== "convertOrder") {
          showSuccessToast(response?.data?.message);
          setTimeout(() => {
            setLoader(false);
          }, 5000);
        }

        if (orderCheck === "convertOrder") return "convertOrder";
        setTimeout(() => {
          cancelQuote();
        }, 5000);
      } else {
        const inputFieldsValidation = response?.error?.data
          ? Object.keys(response?.error?.data?.data)[0]
          : "Please check quote fields!";
        const errorMsg = handleErrorMsg(
          inputFieldsValidation || response?.error?.data?.message,
        );

        showErrorToast(errorMsg);
        setLoader(false);
        if (response?.error?.data?.data?.errors) {
          const errors = response?.error?.data?.data?.errors;
          // console.log("🚀 ~ errors:", errors)
          if (Array.isArray(errors)) {
            const errorMessages = errors.map((error) => error);
            setIsModalOpen(false);
            setErrorModal(true);
            setErrorMessages(errorMessages);
          }
        }
      }
    }
  };

  const handleConvertOrder = async (checkboxState, id) => {
    const check = await handleCreateQuote("convertOrder");
    if (check === "convertOrder") {
      const response = await convertOrderApi({
        quote_id: id,
        notify_email: checkboxState?.email,
        notify_phone: checkboxState?.phone_number,
      });
      if (response?.data?.status) {
        showSuccessToast(response?.data?.message);
        setTimeout(() => {
          cancelQuote();
          setLoader(false);
        }, 5000);
        return true;
      } else {
        showErrorToast(response?.error?.data?.message);
        setLoader(false);
      }
    }
  };
  const handleErrorMsg = (errorMsg) => {
    switch (errorMsg) {
      case "key delivery_address inside address is missing":
        return "Please enter delivery address!";
      case "key billing_address inside address is missing":
        return "Please enter billing address!";
      case "vendor_product":
        return "Please select vendor!";
      case "price_before_tax":
        return "Please enter price before tax!";
      case "must_select_one_quote":
        return "Please create atleast one quote!";
      case "input":
        return "Please enter product name!";
      case "before_tax":
        return "Please enter price before tax!";
      case "UOM":
        return "Please select product unit name!";
      case "quantity":
        return "Please enter product quantity!";
      case "hsn_sac_size":
        return "HSN Code should not be empty and should be MIN 6 digit & MAX 8 digits";
      default:
        return "Please enter all required information!";
    }
  };

  const handleCheckError = () => {
    if (!delivery_address?.id) {
      return {
        check: true,
        groupedErrors: [
          {
            errors: [
              {
                message: handleErrorMsg(
                  "key delivery_address inside address is missing",
                ),
              },
            ],
          },
        ],
      };
    }
    if (!billing_address?.id) {
      return {
        check: true,
        groupedErrors: [
          {
            errors: [
              {
                message: handleErrorMsg(
                  "key billing_address inside address is missing",
                ),
              },
            ],
          },
        ],
      };
    }
    if (dataSource[0].length === 0) {
      return {
        check: true,
        groupedErrors: [
          { errors: [{ message: handleErrorMsg("must_select_one_quote") }] },
        ],
      };
    }
    if (!selectedSeller[0]) {
      return {
        check: true,
        groupedErrors: [
          { errors: [{ message: handleErrorMsg("vendor_product") }] },
        ],
      };
    }

    const requiredFields = [
      { key: "input", field: "input" },
      { key: "before_tax", field: "before_tax" },
      { key: "unit_name", field: "UOM" },
      { key: "quantity", field: "quantity" },
    ];

    const groupedErrors = [];
    for (let i = 0; i < dataSource.length; i++) {
      const vendorLabel =
        selectedSeller[i]?.vendor_name || `Sub order ${i + 1}`;
      const rowErrors = [];
      for (let j = 0; j < dataSource[i].length; j++) {
        const currentItem = dataSource[i][j];
        const itemLabel = currentItem?.input || `Item ${j + 1}`;

        requiredFields.forEach(({ key, field }) => {
          if (!currentItem[key]) {
            rowErrors.push({
              sno: j + 1,
              itemLabel,
              message: handleErrorMsg(field),
            });
          }
        });

        if (
          currentItem.hsn_sac?.length !== 0 &&
          (currentItem.hsn_sac.length < 6 || currentItem.hsn_sac.length > 8)
        ) {
          rowErrors.push({
            sno: j + 1,
            itemLabel,
            message: handleErrorMsg("hsn_sac_size"),
          });
        }
      }
      if (rowErrors.length) {
        groupedErrors.push({ vendorLabel, errors: rowErrors });
      }
    }
    return { check: groupedErrors.length > 0, groupedErrors };
  };

  // const disableCondition = handleDisableQuoteButton();

  // const dropDownList1 = productList?.map((element, index) => {
  //   return { ...element, label: element?.product_name, key: index };
  // });

  useEffect(() => {
    if (catalogueList) {
      dispatch(
        getCatalogueByVendor(
          catalogueList?.data?.data?.length ? catalogueList?.data?.data : [],
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogueList]);

  useEffect(() => {
    if (catalogueListDrawerData) {
      dispatch(getCreateOrderDrawerProductData(catalogueListDrawerData || {}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catalogueListDrawerData]);

  useEffect(() => {
    if (productCatalogueData?.status || isSuccessProductCatalogueData) {
      dispatch(getCreateOrderModalProductData(productCatalogueData?.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    productCatalogueData,
    isSuccessProductCatalogueData,
    isFetchingProductCatalogueData,
  ]);

  useEffect(() => {
    if (editData && editData?.status === "fulfilled") {
      dispatch(getRFQQuoteData(editData?.data || {}));
      dispatch(
        getBillingAddress(editData?.data?.data?.address?.billing_address),
      );
      dispatch(
        getDeliveryAddress(editData?.data?.data?.address?.delivery_address),
      );
      dispatch(
        getDeliveryAddressList([
          editData?.data?.data?.address?.delivery_address,
        ]),
      );
      dispatch(
        getBillingAddressList([editData?.data?.data?.address?.billing_address]),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData]);

  useEffect(() => {
    if (editCondition && rfqId && quoteId) {
      getRFQQuoteDetailApi(quoteId);
    } else {
      getRFQUserApi(rfqId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteId, rfqId, editCondition]);
  // useEffect(() => {
  //   if (location?.state?.id && !location?.state?.data) {
  //     getRFQUserApi(userId);
  //   }
  //   if (location?.state?.data) {
  //     getRFQQuoteDetailApi(location?.state?.data);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location.state]);

  useEffect(() => {
    if (addressFlag && rfqId) {
      getRFQUserApi(rfqId);
      dispatch(updateAddressFlag(false));
    }
    if (addressFlag && quoteId) {
      getRFQQuoteDetailApi(quoteId);
      dispatch(updateAddressFlag(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressFlag]);

  useEffect(() => {
    if (quoteData && quoteData?.status === "fulfilled") {
      dispatch(getRFQUserById(quoteData?.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteData]);

  useEffect(() => {
    if (editCondition) {
      const contKey = [];
      initialValue?.tableData?.map((element, i) => {
        contKey.push(element?.length);
        // console.log("🚀 ~ handleTrigger ~ params:", params)
        return null;
      });

      setReportingManager(editData?.data?.data?.reporting_manager);
      setDataSource(initialValue?.tableData || []);
      setCount(contKey);
      dispatch(getBmpPrice(initialValue?.bmpData || []));
      dispatch(getGrandPrice(initialValue?.grandPrice || {}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editQuoteData]);

  const handleCheckboxChange = (e, record, tableIndex) => {
    const newSelectedRows = e.target.checked
      ? [...selectedRows, { ...record, tableIndex }]
      : selectedRows.filter(
          (item) =>
            !(tableIndex === item.tableIndex && record.key === item.key),
        );
    setSelectedRows(newSelectedRows);
    setIsFixedBarVisible(newSelectedRows.length > 0);
  };

  const deselectAll = () => {
    setSelectedRows([]);
    setIsFixedBarVisible(false);
  };

  const showModal = (record, tableIndex) => {
    setAddImageModal(true);
    setCurrentRecord(record);
    setCurrentIndexTable(tableIndex);
  };

  const handleOk = () => {
    setAddImageModal(false);
  };
  const handleCancel = () => {
    setAddImageModal(false);
  };
  const [totalPages, setTotalPages] = useState(null);

  useEffect(() => {
    if (catalogueList?.data?.pagination?.total_pages) {
      setTotalPages(catalogueList?.data?.pagination?.total_pages);
    }
  }, [catalogueList?.data]);
  // const handleTrigger = async (params) => {
  //   setIsLoading(true); // Start loading before triggering
  //   try {
  //     await trigger(params); // Wait for trigger to finish
  //   } finally {
  //     setIsLoading(false); // Always stop loading
  //   }
  // };

  const handleTrigger = async (params) => {
    setIsLoading(true);
    try {
      const result = await trigger(params).unwrap(); // unwrap gives plain response

      const newItems = result?.data || [];

      // ✅ Append instead of replace
      setDropDownList((prevList) => [...prevList, ...newItems]);

      // Optional: store totalPages from response
      setTotalPages(result?.pagination?.total_pages);
    } finally {
      setIsLoading(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const [page, setPage] = useState(1);
  const [lastSearchValue, setLastSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const el = dropdownRef.current;

    if (el) {
      const handleWheel = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = el;
        const atTop = scrollTop === 0;
        const atBottom = scrollTop + clientHeight >= scrollHeight;

        const scrollingDown = e.deltaY > 0;
        const scrollingUp = e.deltaY < 0;

        // ✅ Stop page scroll when dropdown can't scroll further
        if ((atTop && scrollingUp) || (atBottom && scrollingDown)) {
          e.preventDefault();
          e.stopPropagation();
        }
      };

      el.addEventListener("wheel", handleWheel, { passive: false });

      return () => el.removeEventListener("wheel", handleWheel);
    }
  }, []);

  // const handleAutoCompleteScroll = (e, currentSeller) => {
  //   e.preventDefault();
  //   e.stopPropagation();

  //   const isAtBottom =
  //     Math.abs(
  //       e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
  //     ) < 5;

  //   if (!isAtBottom || isLoading) return; // ⛔ Exit if not bottom or already loading

  //   const bottom =
  //     e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

  //   if (bottom && !isLoading) {
  //     setIsLoading(true);
  //     setPage((prevPage) => {
  //       const nextPage = prevPage + 1;
  //       if (totalPages && nextPage > totalPages) {
  //         return prevPage;
  //       }
  //       searchTextDebouncedTrigger({
  //         id: currentSeller.bmp_id,
  //         searchValue: lastSearchValue,
  //         page: nextPage,
  //       });
  //       //  setIsLoading(false);
  //       return nextPage;
  //     });
  //   }
  // };
  const handleAutoCompleteScroll = (e, currentSeller) => {
    const target = e.target;

    const isScrollable = target.scrollHeight > target.clientHeight;
    const isAtTop = target.scrollTop === 0;
    const isAtBottom =
      Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) <
      5;

    if (isScrollable && !(isAtTop || isAtBottom)) {
      e.preventDefault();
      e.stopPropagation();
    }

    // 🔄 Infinite scroll trigger
    if (!isAtBottom || isLoading) return;
    if (totalPages === 0) return;

    setIsLoading(true);
    setPage((prevPage) => {
      const nextPage = prevPage + 1;

      if (totalPages && nextPage > totalPages) {
        setIsLoading(false);
        return prevPage;
      }

      searchTextDebouncedTrigger({
        id: currentSeller.bmp_id,
        searchValue: lastSearchValue,
        page: nextPage,
      });

      return nextPage;
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const searchTextDebouncedTrigger = useCallback(
    debounce(handleTrigger, 1000),
    [],
  );

  const getInputUndoKey = (tableIndex, rowKey) => `${tableIndex}-${rowKey}`;

  const pushInputUndoHistory = (tableIndex, rowKey, value) => {
    const undoKey = getInputUndoKey(tableIndex, rowKey);
    const history = inputUndoHistoryRef.current[undoKey] || [];

    if (history[history.length - 1] === value) return;

    inputUndoHistoryRef.current[undoKey] = [...history, value];
  };

  const updateItemName = (tableIndex, rowKey, value) => {
    setDataSource((prevData) => {
      return prevData.map((table, index) => {
        return tableIndex === index
          ? table.map((item) => {
              if (item.key === rowKey) {
                return { ...item, input: value, mob_sku: "" };
              }
              return item;
            })
          : table;
      });
    });
  };

  const handleClearProduct = (tableIndex, record) => {
    const undoKey = getInputUndoKey(tableIndex, record.key);
    inputUndoHistoryRef.current[undoKey] = [];
    setActiveItemSearchKey(null);
    setDropDownList([]);

    setDataSource((prevData) =>
      prevData.map((table, index) =>
        index === tableIndex
          ? table.map((item) =>
              item.key === record.key
                ? {
                    key: item.key,
                    ...(item.id !== undefined && { id: item.id }),
                    ...(item.quote_vendor !== undefined && {
                      quote_vendor: item.quote_vendor,
                    }),
                    reset_version: (item.reset_version || 0) + 1,
                    input: "",
                    mob_sku: "",
                    unit_name: "",
                    hsn_sac: "",
                    before_tax: "",
                    rfq_price: "",
                    vendor_selling_price: "",
                    imageURL: "",
                    gst: 0,
                    after_tax: "",
                    discount: 0,
                    amount_in: "amount",
                    amount: "",
                    bmp_price: "",
                    quantity: 0,
                    total: 0,
                    mob_margin: { amount_in: "amount", amount: 0 },
                  }
                : item,
            )
          : table,
      ),
    );
  };

  const handleItemNameUndo = (e, tableIndex, row) => {
    if (
      !(e.ctrlKey || e.metaKey) ||
      e.shiftKey ||
      e.key?.toLowerCase() !== "z"
    ) {
      return;
    }

    const undoKey = getInputUndoKey(tableIndex, row.key);
    const history = inputUndoHistoryRef.current[undoKey] || [];

    if (!history.length) return;

    e.preventDefault();
    e.stopPropagation();

    const previousValue = history[history.length - 1];
    inputUndoHistoryRef.current[undoKey] = history.slice(0, -1);
    updateItemName(tableIndex, row.key, previousValue);
  };

  const handleSearchText = (e, tableIndex, row, currentSeller) => {
    const targetValue = e.target.value;
    if (targetValue === "" && row.mob_sku) {
      handleClearProduct(tableIndex, row);
      return;
    }

    pushInputUndoHistory(tableIndex, row.key, row.input || "");
    updateItemName(tableIndex, row.key, targetValue);
    if (targetValue.length >= 3) {
      setActiveItemSearchKey(getInputUndoKey(tableIndex, row.key));
      setLastSearchValue(targetValue);
      setDropDownList([]);
      setPage(1);
      searchTextDebouncedTrigger({
        id: currentSeller.bmp_id,
        searchValue: targetValue,
        page: 1,
      });
    } else {
      setActiveItemSearchKey(null);
    }
  };

  const handleSaveProduct = (e, tableIndex, record, dropDownList) => {
    // console.log("🚀 ~ handleSaveProduct ~ record:", record)
    // console.log("🚀 ~ handleSaveProduct ~ e:", e)
    const productKey = e.key;
    // const productDetail = productList[productKey];
    const productDetail = dropDownList.find(
      (product) => product.vendor_product_id === productKey,
    );
    // console.log("🚀 ~ handleSaveProduct ~ productList:", productList)

    // console.log("🚀 ~ handleSaveProduct ~ productDetail:", productDetail)
    const selectedBeforeTax =
      productDetail?.rfq_price_before_tax || productDetail?.rfq_price || 0;
    const total = totalPrice({
      gst: productDetail?.product_tax_code?.tax,
      before_tax: selectedBeforeTax,
      discount: record.discount,
      quantity: record.quantity,
    });
    const after_tax = priceAfterTax({
      gst: productDetail?.product_tax_code?.tax,
      before_tax: selectedBeforeTax,
    });
    // Calculate margin
    const mobMargin = productDetail?.mob_margin || 0;
    const active = productDetail?.active || 0;
    const negative =
      parseFloat(productDetail?.rfq_price) * parseFloat(record?.quantity || 0) -
      parseFloat(mobMargin) * parseFloat(record?.quantity || 0);

    const bmp =
      active === 0
        ? negative < 0
          ? 0
          : negative
        : (parseFloat(productDetail?.rfq_price) *
            parseFloat(record?.quantity || 0)) /
          (1 + parseFloat(mobMargin) / 100);
    setDataSource((prevData) => {
      return prevData.map((table, index) => {
        return tableIndex === index
          ? table.map((item) => {
              if (item.key === record.key) {
                return {
                  ...item,
                  input: productDetail.product_name,
                  mob_sku: productDetail.mob_sku,
                  hsn_sac: productDetail.hsn_code,
                  before_tax: selectedBeforeTax,
                  rfq_price: selectedBeforeTax,
                  vendor_selling_price: productDetail.price_before_tax,
                  imageURL: productDetail.product_image,
                  total: total,
                  gst: productDetail.product_tax_code.tax,
                  after_tax: after_tax,
                  amount: 0,
                  // bmp_price: total,
                  bmp_price: mobMargin ? bmp : "",
                  unit_name: productDetail.unit,
                };
              }
              return item;
            })
          : table;
      });
    });
    setActiveItemSearchKey(null);
    dispatch(getCatalogueByVendor([]));
  };

  let defaultColumns = [];
  const columsHeader = (table, tableIndex, currentSeller, editCondition) => {
    defaultColumns = [
      {
        title: "Sno",
        key: "sno",
        width: "2%",
        align: "center",
        render: (_, __, index) => index + 1,
      },
      {
        title: `${table.length} Items`,
        key: "icon",
        dataIndex: "input",
        width: "28%",
        // maxWidth: "400px",
        render: (params, record, index) => {
          const itemSearchKey = getInputUndoKey(tableIndex, record.key);
          const shouldShowItemOptions =
            activeItemSearchKey === itemSearchKey &&
            !record.mob_sku &&
            String(params || "").length >= 3;

          return (
            <>
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "8px",
                }}
              >
                <Checkbox
                  onChange={(e) => handleCheckboxChange(e, record, tableIndex)}
                  checked={selectedRows.some(
                    (selectedRow) =>
                      tableIndex === selectedRow.tableIndex &&
                      selectedRow.key === record.key,
                  )}
                />
                <Avatar
                  shape="square"
                  size={60}
                  style={{ backgroundColor: "#e5e5e5", cursor: "pointer" }}
                  icon={<UploadImage />}
                  onClick={() => showModal(record, tableIndex)}
                  src={`${baseUrl}${record?.imageURL}`}
                />
                {/* <Dropdown
                  overlay={
                    <Menu
                      style={{maxHeight: "300px", overflow: "auto"}}
                      onClick={(e) => handleSaveProduct(e, tableIndex, record)}>
                      {dropDownList?.map((item, index) => (
                        // <>
                        //   <Menu.Item
                        //     key={item.key}
                        //     value={item}
                        //     style={{padding: "7px 12px"}}>
                        //     {item.product_name}
                        //   </Menu.Item>
                        //   {index !== dropDownList.length - 1 && (
                        //     <Divider style={{margin: "5px"}} />
                        //   )}
                        // </>
                        <>
                        {item.bmp_id ===
                          selectedSeller[tableIndex].bmp_id && (
                          <Menu.Item
                            key={item.key}
                            value={item}
                            style={{ padding: "7px 12px" }}
                          >
                            {item.product_name}
                          </Menu.Item>

                          // {index !== dropDownList.length - 1 && (
                          //   <Divider style={{margin: "5px"}} />
                          // )}
                        )}
                        </>
                      ))}
                    </Menu>
                  }
                  style={{fontWeight: 500, color: "#0a243f"}}
                  trigger={["click"]}>
                  <TextArea
                    className="custom-textarea"
                    rows={3}
                    placeholder="Enter Item Name"
                    value={params}
                    style={{
                      width: "75%",
                      border: "1px solid #fff",
                      borderRadius: "8px",
                      overflowY: "auto",
                    }}
                    onChange={(e) =>
                      handleSearchText(e, tableIndex, record, currentSeller)
                    }
                  />
                </Dropdown> */}

                <AutoComplete
                  className="custom-textarea-autocomplete"
                  popupClassName="custom-textarea-autocomplete-dropdown"
                  placement="bottomLeft"
                  dropdownAlign={{ offset: [0, 40] }}
                  style={{ width: "80%", marginTop: "-60px" }}
                  open={shouldShowItemOptions ? undefined : false}
                  options={[
                    // Filter and map the actual dropdown items
                    ...(shouldShowItemOptions
                      ? dropDownList
                          ?.filter(
                            (item) =>
                              item.bmp_id ===
                              selectedSeller[tableIndex]?.bmp_id,
                          )
                          ?.map((item) => ({
                            // value: item.key,
                            value: item.vendor_product_id,
                            // label: item.product_name,
                            label: (
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  maxWidth: "100%", // allow responsive shrink
                                }}
                              >
                                <img
                                  src={item.product_image} // replace with actual image property name
                                  alt={item.product_name}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                />
                                <span
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    maxWidth: "100%", // adjust as needed
                                    display: "inline-block",
                                  }}
                                >
                                  {item.product_name}
                                </span>
                              </div>
                            ),
                          })) || []
                      : []),

                    // Append a loading spinner if loading
                    ...(shouldShowItemOptions && isLoading
                      ? [
                          {
                            value: "loading",
                            label: (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "center",
                                  padding: "8px 0",
                                }}
                              >
                                <Spin size="small" />
                              </div>
                            ),
                            disabled: true,
                          },
                        ]
                      : []),
                  ]}
                  //                options={dropDownList
                  //   ?.filter(item => item.bmp_id === selectedSeller[tableIndex]?.bmp_id)
                  //   ?.map(item => {
                  //     console.log("Mapped item:", item); // 🔍 This will log each item

                  //     return {
                  //       value: item.vendor_product_id, // check if this is undefined or missing
                  //       label: item.product_name,
                  //     };
                  //   })
                  // }

                  //  allowClear={false}
                  //  placeholder="UnClearable"
                  value={params}
                  onSelect={(value, option) =>
                    handleSaveProduct(
                      { key: option.value },
                      tableIndex,
                      record,
                      dropDownList,
                    )
                  }
                  onSearch={(text) =>
                    handleSearchText(
                      { target: { value: text } },
                      tableIndex,
                      record,
                      currentSeller,
                    )
                  }
                  //  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  onPopupScroll={(e) => {
                    const { scrollTop, scrollHeight, clientHeight } = e.target;

                    // Dynamically detect when the user is near the bottom (within 50px)
                    if (scrollTop + clientHeight >= scrollHeight - 50) {
                      handleAutoCompleteScroll(e, currentSeller);
                    }
                  }}
                >
                  <TextArea
                    rows={3}
                    value={params}
                    placeholder="Enter Item Name"
                    className="custom-textarea"
                    status={
                      showFieldErrors && !record.input ? "error" : undefined
                    }
                    allowClear
                    onChange={(e) =>
                      handleSearchText(e, tableIndex, record, currentSeller)
                    }
                    onKeyDown={(e) => handleItemNameUndo(e, tableIndex, record)}
                    //  allowClear={{ clearIcon: <CloseSquareFilled /> }}
                    style={{
                      border:
                        showFieldErrors && !record.input
                          ? undefined
                          : "1px solid #d9d9d9",
                      borderRadius: "8px",
                      overflowY: "auto",
                      overscrollBehavior: "contain",
                    }}
                  />
                </AutoComplete>
              </Col>
            </>
          );
        },
      },
      {
        // minWidth: "300px",
        //  Width: "100px",
        width: "22%",
        title: (
          <Col
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Text style={{ fontFamily: "Inter", fontWeight: 500 }}>
              Unit name
            </Text>
            <Text style={{ fontFamily: "Inter", fontWeight: 500 }}>
              Price (Before tax)
            </Text>
          </Col>
        ),
        key: 1,
        dataIndex: "unit_name",
        height: "60px",
        render: (params, record) => {
          return (
            <>
              <UnitNameCell
                params={params}
                record={record}
                dataSource={dataSource}
                tableIndex={tableIndex}
                setDataSource={setDataSource}
                hasError={{
                  unit_name: showFieldErrors && !record.unit_name,
                  before_tax: showFieldErrors && !record.before_tax,
                }}
              />
            </>
          );
        },
        unit_name: "unit_name",
        before_tax: "before_tax",
        after_tax: "after_tax",
        hsn_sac: "hsn_sac",
        title1: "Unit Name",
        title2: "Before Tax",
        tableIndex: tableIndex,
        total: "total",
        bmp_price: "bmp_price",
      },
      {
        width: "35%",
        flex: 4,
        title: (
          <Col
            style={{
              display: "flex",
              justifyContent: "space-between",
              Width: "100px",
            }}
          >
            <Text style={{ fontFamily: "Inter", fontWeight: 500 }}>GST%</Text>
            <Text style={{ fontFamily: "Inter", fontWeight: 500 }}>
              Price (After tax)
            </Text>
            <Text style={{ fontFamily: "Inter", fontWeight: 500 }}>
              Discount
            </Text>
            <Text style={{ fontFamily: "Inter", fontWeight: 500 }}>
              Quantity
            </Text>
          </Col>
        ),
        key: 2,
        dataIndex: "gst",

        render: (params, record) => {
          return (
            <GstCell
              params={params}
              record={record}
              dataSource={dataSource}
              tableIndex={tableIndex}
              setDataSource={setDataSource}
              editCondition={editCondition}
              hasError={{
                quantity: showFieldErrors && !record.quantity,
              }}
            />
          );
        },
        gst: "gst",
        after_tax: "after_tax",
        discount: "discount",
        quantity: "quantity",
        mob_margin: "mob_margin",
        amount_in: "amount_in",
        amount: "amount",
        bmp_price: "bmp_price",
        total: "total",
        title1: "Column 1 Title",
        title2: "Column 2 Title",
        tableIndex: tableIndex,
      },
      {
        flex: 1,
        width: "13%",
        title: "Total",
        dataIndex: "total",
        align: "left ",
        render: (_, record) => {
          return (
            <>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "100%",
                  marginBottom: "20px",
                }}
              >
                <Text
                  level={5}
                  style={{
                    fontWeight: 500,
                    cursor: "not-allowed",
                  }}
                >
                  ₹ {totalPrice(record).toFixed(2)}
                </Text>
                <Popconfirm
                  key={record.key}
                  title={
                    <Text
                      style={{
                        display: "block",
                      }}
                    >
                      Are you sure ?
                    </Text>
                  }
                  placement="left"
                  trigger="click"
                  style={{ width: "150px" }}
                  onConfirm={() =>
                    handleDeleteRow(record.key, tableIndex, record)
                  }
                >
                  <Col
                    className="col-delete-icon"
                    style={{
                      height: "30px",
                      width: "30px",
                      cursor: "pointer",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <DeleteIcon />
                  </Col>
                </Popconfirm>
              </Col>
              <Col
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <DragHandle />

                <Button.Group size="small">
                  <Button
                    value="large"
                    disabled={
                      record?.key ===
                      dataSource[tableIndex]?.[
                        dataSource[tableIndex].length - 1
                      ]?.key
                    }
                    onClick={() =>
                      handleMoveRow(record.key, "down", tableIndex)
                    }
                    style={{
                      backgroundColor: "#f3f2ef",
                      borderRadius: "8px 0 0 8px",
                      height: "27px",
                    }}
                  >
                    <CaretDownOutlined />
                  </Button>

                  <Button
                    value="small"
                    disabled={
                      record.key === dataSource[tableIndex]?.[0]?.key
                    }
                    onClick={() =>
                      handleMoveRow(record.key, "up", tableIndex)
                    }
                    style={{
                      backgroundColor: "#f3f2ef",
                      borderRadius: "0 8px 8px 0",
                      height: "27px",
                    }}
                  >
                    <CaretUpOutlined />
                  </Button>
                </Button.Group>
              </Col>
            </>
          );
        },
      },
    ];
    return defaultColumns;
  };
  const handleDeleteRow = async (key, tableIndex, record) => {
    setDataSource((prevDataSource) => {
      const updatedData = prevDataSource.map((tableRows, i) => {
        if (i === tableIndex) {
          const updatedTableRows = tableRows.filter((row) => row.key !== key);
          return updatedTableRows;
        }
        return tableRows;
      });
      return updatedData;
    });

    if (editCondition && record?.id) {
      const params = { quote_item_id: record?.id };
      const response = await deletTableRowApi(params);
      if (response?.data?.status) {
        showSuccessToast(response?.data?.message);
      } else {
        showErrorToast(response?.error?.data?.message);
      }
    }
  };

  const handleDragEnd = (event, tableIndex) => {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    setDataSource((prevDataSource) => {
      const currentTable = prevDataSource[tableIndex] || [];

      const oldIndex = currentTable.findIndex(
        (item) => String(item.key) === String(active.id),
      );

      const newIndex = currentTable.findIndex(
        (item) => String(item.key) === String(over.id),
      );

      if (oldIndex === -1 || newIndex === -1) {
        return prevDataSource;
      }

      const updatedTable = arrayMove(currentTable, oldIndex, newIndex);

      const updatedDataSource = [...prevDataSource];
      updatedDataSource[tableIndex] = updatedTable;

      return updatedDataSource;
    });
  };

  const handleMoveRow = (key, direction, tableIndex) => {
    setDataSource((prevDataSource) => {
      const currentTable = [...(prevDataSource[tableIndex] || [])];

      const currentIndex = currentTable.findIndex(
        (item) => item.key === key,
      );

      if (currentIndex === -1) {
        return prevDataSource;
      }

      const newIndex =
        direction === "up"
          ? currentIndex - 1
          : currentIndex + 1;

      if (newIndex < 0 || newIndex >= currentTable.length) {
        return prevDataSource;
      }

      const updatedDataSource = [...prevDataSource];

      updatedDataSource[tableIndex] = arrayMove(
        currentTable,
        currentIndex,
        newIndex,
      );

      return updatedDataSource;
    });
  };

  const handleExcelUpload = async (tableIndex, file) => {
    if (!isExcelFile(file)) {
      showErrorToast("Please upload only .xls or .xlsx files.");
      return;
    }

    setExcelUploadTableIndex(tableIndex);
    setIsExcelProcessing(true);

    try {
      const response = await quoteExcelPreviewApi(file);

      if (response?.error || response?.data?.status === false) {
        showErrorToast(
          response?.error?.data?.message ||
            response?.data?.message ||
            "Failed to preview Excel file.",
        );
        return;
      }

      const previewGroups = extractQuoteExcelPreviewGroups(response);

      if (!previewGroups.length) {
        showErrorToast("No valid items were found in the uploaded Excel file.");
        return;
      }

      const mergedPreviewData = await mergeQuoteExcelPreviewData({
        count,
        dataSource,
        previewGroups,
        selectedSeller,
        startIndex: tableIndex,
      });

      startExcelImportTransition(() => {
        setDataSource(mergedPreviewData.dataSource);
        setSelectedSeller(mergedPreviewData.selectedSeller);
        setCount(mergedPreviewData.count);
      });

      showSuccessToast(
        response?.data?.message || "Excel items imported successfully.",
      );
    } finally {
      setIsExcelProcessing(false);
    }
  };

  useEffect(() => {
    if (
      excelUploadTableIndex !== null &&
      !isExcelPreviewApiLoading &&
      !isExcelProcessing &&
      !isExcelUiPending
    ) {
      setExcelUploadTableIndex(null);
    }
  }, [
    excelUploadTableIndex,
    isExcelPreviewApiLoading,
    isExcelProcessing,
    isExcelUiPending,
  ]);

  const handleAddRow = (tableIndex, rowData) => {
    let newRow = {};
    if (rowData) {
      newRow = {
        key: count[tableIndex] + 1,
        unit_name: rowData?.unit || "",
        discount: 0,
        mob_margin: { amount_in: "amount", amount: 0 },
        amount_in: "amount",
        amount: "",
        quantity: 0,
        input: rowData?.product_name || rowData?.item_name_title || "",
        mob_sku: rowData?.mob_sku || "",
        hsn_sac: rowData?.hsn_code || "",
        before_tax:
          rowData?.rfq_price_before_tax ||
          rowData?.vendor?.rfq_price ||
          rowData?.rfq_price ||
          "",
        rfq_price:
          rowData?.rfq_price_before_tax ||
          rowData?.vendor?.rfq_price ||
          rowData?.rfq_price ||
          "",
        vendor_selling_price:
          rowData?.price_before_tax ||
          rowData?.vendor?.vendor_selling_price ||
          "",
        imageURL: rowData?.product_image || rowData?.images?.[0]?.image || "",
        // total: total,
        gst: rowData?.product_tax_code?.tax || 0,
        // after_tax: after_tax,
        // bmp_price: total,
      };
    } else {
      newRow = {
        key: count[tableIndex] + 1,
        input: "",
        unit_name: "",
        before_tax: "",
        hsn_sac: "",
        gst: 0,
        imageURL: "",
        after_tax: "",
        discount: 0,
        mob_margin: { amount_in: "amount", amount: 0 },
        amount_in: "amount",
        amount: "",
        bmp_price: "",
        quantity: 0,
        total: 0,
      };
    }
    setDataSource((table) => {
      const updatedData = table.map((tableRows, i) =>
        i === tableIndex ? [...tableRows, newRow] : tableRows,
      );
      return updatedData;
    });
    setCount((prevCount) => {
      return prevCount.map((item, index) =>
        tableIndex === index ? item + 1 : item,
      );
    });
  };

  const moveRowsToTable = (value) => {
    let moveData = [...selectedRows];
    let removeItems = selectedRows.reduce(
      (acc, { tableIndex, key }) => {
        if (acc[tableIndex]) {
          acc[tableIndex] = acc[tableIndex].filter((item) => item.key !== key);
        }
        return acc;
      },
      [...dataSource],
    );

    // let newTable = moveData.map((item, index) => {
    //   const {tableIndex, key, ...rest} = item;
    //   return {key: index + 1, ...rest};
    // });
    let newTable = moveData.map((item, index) => {
      const { tableIndex, key, id, quote_vendor, ...rest } = item;
      return { key: index + 1, id: 0, quote_vendor: 0, ...rest };
    });
    if (value === "new_sub_order") {
      let finalData = [...removeItems, newTable].filter(
        (item, index) =>
          item?.length !== 0 || selectedSeller[index]?.vendor_name,
      );
      let finalSelectedSeller = [];
      [...removeItems, newTable]?.map((item, index) => {
        if (item?.length !== 0 || selectedSeller[index]?.vendor_name) {
          finalSelectedSeller.push(selectedSeller[index] || {});
        }
        return null;
      });
      setDataSource(finalData);
      setSelectedSeller(finalSelectedSeller);
      setCount([...count, newTable.length]);
    } else {
      let movedTableRows = [...removeItems[value], ...selectedRows];
      // console.log("🚀 ~ moveRowsToTable ~ movedTableRows:", movedTableRows)
      movedTableRows = movedTableRows.map((item, index) => {
        const { tableIndex, key, ...rest } = item;
        return { key: index + 1, ...rest };
      });
      let finalArray = removeItems.map((table, index) => {
        if (index === value) {
          return movedTableRows;
        } else {
          return table;
        }
      });

      let finalData = finalArray?.filter(
        (item, index) =>
          item?.length !== 0 || selectedSeller[index]?.vendor_name,
      );
      let finalSelectedSeller = [];
      finalArray?.map((item, index) => {
        if (item?.length !== 0 || selectedSeller[index]?.vendor_name) {
          finalSelectedSeller.push(selectedSeller[index] || {});
        }
        return null;
      });
      setDataSource(finalData);
      setSelectedSeller(finalSelectedSeller);
      setCount(
        count.map((item, index) =>
          index === value ? movedTableRows.length : item,
        ),
      );
    }
    setSelectedRows([]);
    setIsFixedBarVisible(false);
  };

  const handleDeleteTable = async (index, quote_vendor) => {
    const updatedTables = dataSource.filter((_, i) => i !== index);
    const sellerList = selectedSeller.filter((_, i) => i !== index);
    const countList = count.filter((_, i) => i !== index);
    const bmp = bmpPrice.filter((_, i) => i !== index);
    dispatch(getBmpPrice(bmp));
    setCount(countList);
    setSelectedSeller(sellerList);
    setDataSource(updatedTables);
    if (editCondition && quote_vendor?.quote_vendor) {
      const params = { quote_vendor: quote_vendor?.quote_vendor };
      const response = await deletTableApi(params);
      if (response?.data?.status) {
        showSuccessToast(response?.data?.message);
      } else {
        showErrorToast(response?.error?.data?.message);
      }
    }
  };

  const AddNewSubOrder = () => {
    const table = [
      {
        key: 1,
        input: "",
        unit_name: "",
        before_tax: "",
        hsn_sac: "",
        gst: 0,
        imageURL: "",
        after_tax: "",
        discount: 0,
        mob_margin: { amount_in: "amount", amount: 0 },
        amount_in: "amount",
        amount: "",
        bmp_price: "",
        quantity: 0,
        total: 0,
      },
    ];
    const newTableData = [...dataSource, table];
    setDataSource(newTableData);
    setCount([...count, 1]);
    setSelectedSeller([...selectedSeller, {}]);
  };

  const [reportingManagersData, setReportingManagersData] = useState([]);
  const [getReportingManagers, { data: reportingManagers, error }] =
    useLazyGetReportingManagersQuery();
  const handleSave = async () => {
    handleCreateQuote();
  };

  useEffect(() => {
    getReportingManagers();
  }, [getReportingManagers]);

  useEffect(() => {
    if (reportingManagers) {
      setReportingManagersData(reportingManagers.data);
      const userName = localStorage.getItem("userName");
      const managers = reportingManagers.data;
      const matchingManagers = managers.filter((manager) =>
        manager.reporting_person.includes(userName),
      );
      if (matchingManagers.length > 0) {
        setReportingManager(matchingManagers[0]);
      }

      //setReportingManager(reporting_manager)
    } else if (error) {
      console.error("Failed to fetch reporting managers:", error);
    }
  }, [reportingManagers, error]);

  useEffect(() => {
    setReportingManagersData([]);
  }, []);

  const handleMenuClick = (e) => {
    const selectedManager = reportingManagersData.find((reportingManager) => {
      return Number(reportingManager.id) === Number(e.key);
    });
    setReportingManager({
      id: selectedManager.id,
      reporting_to: selectedManager.reporting_to,
      reporting_person: selectedManager.reporting_person,
    });
  };

  const [open, setOpen] = useState(false);
  const [reportingManager, setReportingManager] = useState(null);
  const handleOpenChange = (nextOpen, info) => {
    setOpen(nextOpen);
  };

  const transformReportingManagers = (reportingManagers) => {
    const reportingManagerArray = Array.isArray(reportingManagers)
      ? reportingManagers
      : [];
    return reportingManagerArray.map((item) => ({
      label: item.reporting_person,
      key: item.id.toString(),
    }));
  };

  return (
    <>
      <QuoteConfirmationModal
        isModalOpen={isModalOpen}
        editCondition={editCondition}
        setIsModalOpen={setIsModalOpen}
        setReportingManager={setReportingManager}
        handleSave={handleSave}
        handleMenuClick={handleMenuClick}
        handleOpenChange={handleOpenChange}
        reportingManagers={transformReportingManagers(reportingManagersData)}
        reportingManager={reportingManager}
        setOpen={setOpen}
        open={open}
        //  handleSaveApi={handleSaveApi}
        loading={false} // Pass loading state if needed
      />

      <CreateQuoteProfileSection
        editQuoteData={editQuoteData}
        editData={editData}
        editCondition={editCondition}
        quoteData={quoteData}
        handleMenuClick={handleMenuClick}
        handleOpenChange={handleOpenChange}
        reportingManagers={transformReportingManagers(reportingManagersData)}
        reportingManager={reportingManager}
        setReportingManager={setReportingManager}
        setOpen={setOpen}
        open={open}
        // handleCreateQuote={handleCreateQuote}
        handleCreateQuote={showConfirmationModal}
        cancelQuote={editCondition ? handleCancelOpenModal : cancelQuote}
        loading={
          editCondition ? isUpdateLoading || loader : isCreateLoading || loader
        }
        dataSource={dataSource}
        bmpPrice={bmpPrice}
        grandPrice={grandPrice}
        handleConvertOrder={handleConvertOrder}
        // disableCondition={disableCondition}
        ewaybilltrigger={ewaybilltrigger}
        setEwaybilltrigger={setEwaybilltrigger}
      />

      {editData?.isLoading ? (
        <>
          <TableSkeleton />
        </>
      ) : (
        <>
          {" "}
          {dataSource?.map((table, tableIndex) => {
            const tableColumns = columsHeader(
              table,
              tableIndex,
              selectedSeller[tableIndex],
              editCondition,
            );

            const sortableItems = table.map(
              (item) => String(item.key),
            );

            return (
              <DndContext
                key={`dnd-context-${tableIndex}`}
                sensors={sensors}
                collisionDetection={closestCenter}
                modifiers={[restrictToVerticalAxis]}
                onDragEnd={(event) => handleDragEnd(event, tableIndex)}
              >
                <SortableContext
                  items={sortableItems}
                  strategy={verticalListSortingStrategy}
                >
                  <Table
                    key={`${tableIndex}`}
                    rowKey="key"
                    className={"rfq-table"}
                    style={{
                      borderRadius: "8px",
                      boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.16)",
                      border: "solid 1px #eaeaea",
                      marginBottom: "48px",
                    }}
                    columns={
                      selectedSeller[tableIndex] || tableIndex !== 0
                        ? tableColumns
                        : []
                    }
                    dataSource={
                      selectedSeller[tableIndex] || tableIndex !== 0
                        ? table
                        : []
                    }
                    title={() => (
                      <TableHeader
                        handleAddRow={handleAddRow}
                        tableIndex={tableIndex}
                        handleDeleteTable={handleDeleteTable}
                        selectedSeller={selectedSeller}
                        setSelectedSeller={setSelectedSeller}
                        sellerList={sellerList}
                        getAllVendors={getAllVendors}
                        initialValue={initialValue.venderList}
                        editCondition={editCondition}
                        key={tableIndex}
                        bmpPrice={bmpPrice}
                        getBmpPrice={getBmpPrice}
                        getProductApi={getcatalogueListDrawerApi}
                        getProductModalApi={getProductCatalogueDataApi}
                        QuoteCreationFlag={0}
                        handleExcelUpload={handleExcelUpload}
                        isExcelUploading={
                          (isExcelPreviewApiLoading ||
                            isExcelProcessing ||
                            isExcelUiPending) &&
                          excelUploadTableIndex === tableIndex
                        }
                      />
                    )}
                    footer={() => (
                      <TableFooter
                        handleAddRow={handleAddRow}
                        tableIndex={tableIndex}
                        selectedSeller={selectedSeller}
                        dataSource={dataSource}
                        key={tableIndex}
                        editCondition={editCondition}
                        bmpPrice={bmpPrice}
                        getBmpPrice={getBmpPrice}
                        billingAddressSelector={billing_address}
                        RFQFlag={true}
                      />
                    )}
                    locale={{
                      emptyText: selectedSeller[tableIndex]?.vendor_name ? (
                        ""
                      ) : (
                        <EmptyTable
                          mainText={
                            "Please select the seller to add items to the RFQ."
                          }
                        />
                      ),
                    }}
                    pagination={false}
                    components={{
                      body: {
                        row: DraggableRow,
                      },
                    }}
                  />
                </SortableContext>
              </DndContext>
            );
          })}
        </>
      )}
      <AddImages
        addImageModal={addImageModal}
        setAddImageModal={setAddImageModal}
        showModal={showModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
        record={currentRecord}
        currentIndexTable={currentIndexTable}
        dataSource={dataSource}
        setDataSource={setDataSource}
      />

      <Checkout
        onClick={showConfirmationModal}
        AddNewSubOrder={AddNewSubOrder}
        selectedSeller={selectedSeller}
        dataSource={dataSource}
        editCondition={editCondition}
        buttonText={editCondition ? "UPDATE QUOTE" : "CREATE QUOTE"}
        handleCreateQuote={showConfirmationModal}
        cancelQuote={editCondition ? handleCancelOpenModal : cancelQuote}
        loading={
          editCondition ? isUpdateLoading || loader : isCreateLoading || loader
        }
        grandPrice={grandPrice}
        bmpPrice={bmpPrice}
        editQuoteData={editQuoteData}
        getGrandPrice={getGrandPrice}
        // disableCondition={disableCondition}
        billingAddressSelector={billing_address}
        data={editCondition ? editQuoteData : quoteData?.data?.data}
        RFQFlag={true}
      />
      <CancelCreateQuoteModal
        open={cancelModal}
        handleOk={handleCancelModal}
        handleSave={cancelQuote}
      />

      <CreateQuoteValidationModal
        open={errorModal}
        handleOk={handleErrorModal}
        errorMessages={errorMessages}
      />
      {isFixedBarVisible && (
        <Affix
          offsetBottom={10}
          offsetTop={10}
          style={{ position: "sticky", zIndex: 999 }}
        >
          <Col
            style={{
              width: "100%",
              height: "80px",
              backgroundColor: "#fff",
              display: "flex",
              padding: "0 40px",
              boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.16)",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col style={{ display: "flex", gap: "24px" }}>
              <Text
                style={{
                  width: "150px",
                  color: "#0a243f",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                {selectedRows?.length} Items selected
              </Text>
              <Text
                style={{
                  color: "#2973f0",
                  fontSize: "14px",
                  fontWeight: 500,
                  paddingTop: "2px",
                  cursor: "pointer",
                }}
                onClick={deselectAll}
              >
                Deselect all
              </Text>
            </Col>
            <MoveItemModal
              moveRowsToTable={moveRowsToTable}
              dataSource={dataSource}
              selectedSeller={selectedSeller}
              selectedRows={selectedRows}
            />
          </Col>
        </Affix>
      )}
      <QuoteLoading
        open={
          editCondition ? isUpdateLoading || loader : isCreateLoading || loader
        }
      />
    </>
  );
};
export default CreateQuoteTable;
